import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { StatsGroup } from '../../helpers/locationStatistics';
import { StatsDetailRow, StatsValue } from './StatsDetailRow';

export const StatsRow = ({ group, expanded, onToggle }: { group: StatsGroup; expanded: boolean; onToggle: () => void }) => {
    const { t } = useTranslation();
    const panelId = useId();
    const title = t(`stats.group_${group.id}`);
    return <>
        <tr className={expanded ? 'stats-summary-row stats-summary-row--open' : 'stats-summary-row'}>
            <th scope="row"><button type="button" aria-expanded={expanded} aria-controls={panelId} onClick={onToggle}>
                <span className="stats-disclosure-icon" aria-hidden="true">{expanded ? '−' : '+'}</span>{title}
            </button></th>
            <td><StatsValue value={group.institutions} /></td><td><StatsValue value={group.objects} /></td><td><StatsValue value={group.points} /></td>
        </tr>
        <tr id={panelId} hidden={!expanded} className="stats-expanded-row"><td colSpan={4}>
            {expanded && <StatsDetailRow details={group.categories} label={title} />}
        </td></tr>
    </>;
};
